module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 605
// module chunks = 0